
import React, { useRef } from 'react';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import { ROADMAP } from '../constants';

const Roadmap: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end end"]
  });

  const scaleY = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const robotY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <div id="roadmap" ref={containerRef} className="relative py-20 px-6 max-w-5xl mx-auto overflow-hidden">
      <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-1.5 bg-gray-800 rounded-full hidden md:block">
        <motion.div 
          style={{ scaleY, transformOrigin: "top" }} 
          className="w-full h-full bg-gradient-to-b from-rose-400 to-rose-700 shadow-[0_0_15px_rgba(244,114,114,0.5)]"
        />
        <motion.div 
          style={{ top: robotY }} 
          className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 text-4xl"
        >
          🤖
        </motion.div>
      </div>

      <div className="space-y-24">
        {ROADMAP.map((item, idx) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, x: idx % 2 === 0 ? -50 : 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            viewport={{ once: true }}
            className={`flex flex-col md:flex-row items-center gap-8 ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`}
          >
            <div className="w-full md:w-1/2" />
            
            <div className="relative z-10 hidden md:block">
              <div className="w-8 h-8 rounded-full bg-rose-500 border-4 border-gray-900 shadow-lg" />
            </div>

            <div className="w-full md:w-1/2">
              <div className="glass-card p-8 rounded-3xl group hover:border-rose-500/50 transition-colors">
                <span className="text-rose-400 font-bold text-xl mb-2 block">{item.id}</span>
                <h3 className="text-2xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-400 leading-relaxed">{item.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Roadmap;
